import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export class StoresImportAccessRight {
  public static VIEW_IMPORT_STORES: AuthenticationAccessRight = ({ menuDisplayLevel }) =>  menuDisplayLevel <= 2 || menuDisplayLevel >= 4;
}
